<!-- 创建指令 -->
<template>
	<div>
		<el-dialog :title="dialogTitle" :visible.sync="visible" v-loading.fullscreen="uploadloading"
	element-loading-spinner="el-icon-loading"
	element-loading-background="rgba(0, 0, 0, 0.8)"  :close-on-click-modal="false" width="980px" @close="handleClose" :append-to-body="true">
		<el-form :model="dialogForm" ref="commandForm" :inline="true" label-width="auto" style="margin:10px 0 0 15px">
			<!-- 填写备注 -->
			<el-form-item label="备注">
				<el-input v-model="dialogForm.remark" type="textarea" clearable style="width: 400px" />
			</el-form-item>
		</el-form>
		<el-divider><i class="el-icon-box"></i></el-divider>
		<el-form  :inline="true" label-width="auto" style="margin:10px 0 0 15px">
			<el-form-item label>
				<el-input v-model="searchProductCode" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.clientProductCode')" type="textarea" clearable />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-plus" @click="handleSearchProduct">{{$t('commonInfo.addBtn')}}</el-button>
			</el-form-item>
			<el-form-item>
				<el-upload
				  <el-upload
					  class="upload-demo"
					  :action="$baseUrl + '/toborder/wms/product/addMultiFbxStockProduct'"
					  :before-upload="beforeUpload"
					  :on-success="handlesuccess"
					  :on-error="handleError"
					  :on-progress="handleProgress"
					  multiple
					  :show-file-list="false"
					  :file-list="fileList"
					  accept=".xls, .xlsx"
					  :headers="headers"
					  name="productFile"
					  style="margin-right:15px"
					>
					  <el-button type="success">{{$t('ksaWhFBXOrderPage.multipleImportProduct')}}</el-button>
				</el-upload>
			</el-form-item>
			<el-form-item>
				<el-button @click="handleDownloadUrl">{{$t('commonInfo.downloadTemplate')}}</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="handleDeleteAll">{{$t('commonInfo.deleteAllBtn')}}</el-button>
			</el-form-item>
		</el-form>
		<el-table style="margin:5px 15px;width: calc(100% - 30px)" ref="productTable"
			v-loading="inventoryLoading" :data="inventoryData" :cell-style="cellStyle" border 
			show-summary :summary-method="getSummaries"
			>
			<el-table-column :label="$t('commonInfo.clientProductCode')" width="110" align="center" prop="clientProductCode" />
			<el-table-column :label="$t('commonInfo.productName')" align="center" prop="productNm" />
			<el-table-column prop="img" :label="$t('commonInfo.photo')" align="center" width="80" >
				<template slot-scope="{ row }">
						<img v-if="row.img != null && row.img != ''" :src="row.img" @click="handleViewImg(row.img)" style="width: 60px;height: 60px;"/>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.productQuantity')" align="center" prop="productQuantity" width="100" />
			<el-table-column :label="$t('commonInfo.appointmentQuantity')" align="center" prop="appointmentQuantity" width="130" />
			<el-table-column :label="$t('commonInfo.orderQuantity')" align="center" prop="count">
				<template slot-scope="{ row }">
					<el-input @input="handleNum(row)" v-model.number="row.count" size="small" />
					<span v-if="row.errorNum" style="color: red;font-size: 12px;">{{$t('ksaWhFBXOrderPage.inputCorrectQuantity')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('ksaWhFBXOrderPage.newLabelCode')" align="center" prop="skuNew" width="130">
				<template slot-scope="{ row }">
					<el-input @input="handleNum(row)" v-model="row.skuNew" size="small" />
					<span v-if="row.errorNewSku" style="color: red;font-size: 12px;">{{$t('tipsInfo.inputPlaceholder') + $t('ksaWhFBXOrderPage.newLabelCode')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('ksaWhFBXOrderPage.newLabelQuantity')" align="center" prop="swapCnt">
				<template slot-scope="{ row }">
					<el-input @input="handleNum(row)" v-model.number="row.swapCnt" size="small" />
					<span v-if="row.errorNewNum" style="color: red;font-size: 12px;">{{$t('tipsInfo.inputPlaceholder') + $t('ksaWhFBXOrderPage.newLabelQuantity')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.operationColumn')" align="center" prop="">
				<template slot-scope="{ row }">
					<el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(row.clientProductCode)">{{$t('commonInfo.deleteBtn')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div v-if="hasSkuNewItem" style="margin: 10px 0 0 0; display: inline-block; width: 200px;">
			<!-- 当用户填写了换标信息，显示上传换标文件按钮 -->
			<MutipleUploadNoLimit 
			  v-if="hasSkuNewItem"
			  :tipText="$t('commonInfo.newLabelFileNolimitTips')"
			  :isClearList.sync="clearFileListFlag"
			  @input="getNewLabelExcel"
			  class="fileUploadBtn"
			></MutipleUploadNoLimit>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
			<el-button type="primary" :loading="submitLoading" @click="submit" :disabled="!openBtn || submitLoading">{{submitLoading?$t('commonInfo.dialogBtnSubmiting'):$t('commonInfo.dialogBtnSubmit')}}</el-button>
		</div>

		<el-image-viewer v-if="showImg" :on-close="closeImg" :url-list="imgList" />
	</el-dialog>
	<!-- 导入Excel后错误的对话框 -->
		<el-dialog :lang="$i18n.locale" :title="$t('commonInfo.productInfo')" :visible.sync="dialogErrorVisible" width="640px" :close-on-click-modal="false">
		  <el-table :data="errorData">
		    <el-table-column property="clientProductCode" :label="$t('commonInfo.clientProductCode')" align="center"></el-table-column>
				<el-table-column property="count" :label="$t('commonInfo.orderQuantity')" align="center"></el-table-column>
				<el-table-column property="errorMsg" :label="$t('commonInfo.result')" align="center">
				</el-table-column>
		  </el-table>
		</el-dialog>
	</div>
</template>

<script>
	import MutipleUploadNoLimit from "@/components/upload/mutipleUploadNoLimit";
	export default {
		components: {
			MutipleUploadNoLimit
		},
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		// 监听visible变化，初始化数据
		watch: {
			visible: {
				handler(newVal, oldVal) {
					if (newVal) {
						let token = window.sessionStorage.getItem("token");
			            this.headers = {
			        	  Authorization: token,
			            }
						if(this.skuModelUrl == ''){
							this.getModelUrl();
						}
					}
				},
				deep: true
			}
		},
		data() {
			return {
				dialogTitle: '创建SKU转箱指令',
				dialogForm: {
					remark: '',
				},
				searchProductCode: '',
				inventoryData: [],
				inventoryLoading: false,
				inventoryParams: {
					page: 1,
					limit: 30,
				},
				fileList: [],
				submitLoading: false,
				openBtn: true,
				hasSkuNewItem: false,
				clearFileListFlag: false,
				newLabelFileLink: [],
				headers: {},
				skuModelUrl: '',

				imgList: [],
				showImg: false,
				uploadloading: false,
				// 导入商品信息错误窗口
				dialogErrorVisible:false,
				errorData:[],
			};
		},
		methods: {
			// 改变表格颜色
			cellStyle({row,column,rowIndex,columnIndex}){
				if(row && row.isError === true){
					return {
						background:'burlywood'
					}
				}
				// 明确返回undefined，避免鼠标经过时变背景色
				return undefined;
			},
			// 判断输入数据
			handleNum(row){
				this.checkProduct();
			},
			async getModelUrl(){
				const res = await this.$http.get("/toborder/system/dict/data/list",{
				  params: {
						page:1,
						limit:10,
						dictType:'sys_template_url'
					}
				});
				
				if (res.code === 200) {
					let that = this;
					let data = res.rows;
					data.forEach(item => {
						if(item.dictLabel == 'fulfillment FBX订单下单模版'){
							that.skuModelUrl = item.remark;
						}
					})
				} else {
				  this.$message.error(res.msg);
				}
			},
			// 检测商品列表是否正确
			checkProduct(){
				if(this.inventoryData.length == 0){
					return
				}
				let that = this;
				let isAllRight = true;
				this.hasSkuNewItem = false;//判断是否有填写换标信息，有则显示上传换标文件按钮
				const ruleInt = /^\+?[1-9][0-9]*$/;//正整数
				this.inventoryData.forEach(item => {
					item.isError = false;
					// 三种错误情况
					item.errorNum = false;
					item.errorNewSku = false;
					item.errorNewNum = false;
					if(!ruleInt.test(item.count)){
						item.isError = true;
						item.errorNum = true;
					}
					if(item.count > (item.productQuantity - item.appointmentQuantity)){
						item.isError = true;
						item.errorNum = true;
					}
					// 换标时换标SKU和换标数量要都必填或者都为空
					if(item.skuNew != ""){
						if(item.swapCnt == 0 || item.swapCnt == ''){
							item.isError = true;
							item.errorNewNum = true;
						}else{
							this.hasSkuNewItem = true;
						}
					}
					if(item.swapCnt != "" && item.swapCnt != 0){
						if(item.skuNew == ""){
							item.isError = true;
							item.errorNewSku = true;
						}else{
							this.hasSkuNewItem = true;
						}
						if(item.swapCnt > item.count){
							item.isError = true;
							item.errorNewNum = true;
						}
					}
					//判断是否全部数据下单数量没问题
					if(item.isError){
						isAllRight = false;
					}
				})
				// 数据有问题禁用提交按钮
				this.openBtn = isAllRight?true:false;
			},
			// 搜索商品
			handleSearchProduct(){
				let query = {
					companyProductCodeList:[],
					page:1,
					limit:10,
				}
				if(this.searchProductCode == ''){
					return this.$message.warning(this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.clientProductCode'));
				}else{
					query.companyProductCodeList = this.strToArr(this.searchProductCode);
					query.limit = query.companyProductCodeList.length;
				}
				this.inventoryParams = query;
				this.getInventoryList();
			},
			// 获取库存列表
			async getInventoryList() {
				this.inventoryLoading = true;
				const res = await this.$http.post("/toborder/wms/product/getWmsInventoryInformation", this.inventoryParams);

				if (res.code === 200) {
					this.inventoryLoading = false;
					// 2022-3-15 根据用户输入的商品编码，直接添加为订单下单商品
					let dataList = res.data;
					// this.inventoryTotal = res.data.totalCount;
					if(dataList.length != 0){
						dataList.forEach(item => {
							// item.toEdit = true;
							item.isError = true;
							item.skuNew = '';//换标标签	
							item.swapCnt = '';//换标数量
							if(item.productImages != null && item.productImages != ''){
								let img = JSON.parse(item.productImages);
								item.img = img;
							}
						});
					}
					const dataLength = this.inventoryData.length;
					this.inventoryData = this.inventoryData.concat(dataList);
					this.inventoryData = this.quchong(this.inventoryData);
					if(this.inventoryData.length == dataLength){
						this.$message({
                        title: this.$t('tipsInfo.info'),
                        message: this.$t('ksaWhFBXOrderPage.checkProductTips'),
                        duration: 3000,
							type: 'warning'
                        });
					}
					this.checkProduct();
				} else {
					this.inventoryLoading = false;
					this.$message.error(res.msg);
				}
			},
			// 删除已添加的商品
			handleDelete(code){
				let that = this;
				this.$confirm(this.$t('tipsInfo.deleteRowTips'), this.$t('tipsInfo.warning'), {
					confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
					cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
					type: "warning"
				})
				.then(() => {
					var index = this.inventoryData.findIndex(item => {
						if(item.clientProductCode == code){
							return true;
						}
					})
					this.inventoryData.splice(index, 1);
					this.checkProduct();
					this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
				})
				.catch(() => {});
			},
			// 删除全部商品
			handleDeleteAll(){
				this.$confirm(this.$t('tipsInfo.deleteAllRowTips'), this.$t('tipsInfo.warning'), {
					confirmButtonText: this.$t('commonInfo.dialogBtnConfirm'),
					cancelButtonText: this.$t('commonInfo.dialogBtnCancel'),
					type: "warning"
				})
				.then(() => {
					this.inventoryData = [];
					this.hasSkuNewItem = false;
					this.clearFileListFlag = true;
					this.$message.success(this.$t('tipsInfo.deleteSuccessTips'));
				})
				.catch(() => {});
			},
			//去重数组
			quchong(arr) {
				const res = new Map();
				return arr.filter(
					(list) => !res.has(list.clientProductCode) && res.set(list.clientProductCode, 1)
				);
			},
			// 下载模板
			handleDownloadUrl() {
				window.open(this.skuModelUrl);
			},
			// 获取上传换标附件
			getNewLabelExcel(data) {
				this.newLabelFileLink = [];
				if(data.length > 0){
					data.forEach(item => {
						this.newLabelFileLink.push(item.url);
					})
				}
			},
			// 上传前检查
			beforeUpload(file) {
				let fileNameStr = file.name;
				if(fileNameStr.length > 30){
					return this.$message.warning(this.$t('tipsInfo.uploadFileNameLimitTips'));
				}
			  var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			  const extension = testmsg === "xls";
			  const extension2 = testmsg === "xlsx";
			  if (!extension && !extension2) {
			    this.$message.warning(
			      this.$t('tipsInfo.uploadExcelTypeTips')
			    );
			  }
			  return extension || extension2;
			},
			// 上传成功
			handlesuccess(files, fileList) {
				this.uploadloading = false;
			  if (files.code == 200) {
			    let that = this;
			    
			    if(files.data.productErrorInfoList.length == 0){
			    	this.$message.warning(this.$t('ksaWhFBXOrderPage.checkProductErrorTips'));
			    }else{
						// 判断返回的信息是否正确，如果导入的商品信息没问题则显示在列表上，检测有问题后台返回有问题信息，前端显示
						if(!files.data.success){
							this.errorData = files.data.productErrorInfoList;
							this.dialogErrorVisible = true;
						}else{
							that.$message.success(this.$t('tipsInfo.uploadSuccess'));
							that.dialogForm.skuListLink = files.data.skuListLink;
							that.inventoryData = that.inventoryData.concat(files.data.productErrorInfoList);
							that.inventoryData = that.quchong(that.inventoryData);
							that.checkProduct();
						}
			    }
			  } else if (files.code == 500) {
			    this.$message.error(files.msg);
			  }
			  if (files.code == 401) {
			    this.$message.error(this.$t('tipsInfo.loginOutTips'));
			    window.sessionStorage.removeItem("token");
			    return this.$router.push({
			      path: "/login"
			    });
			  }
			},
			// 上传失败
			handleError(err, file, fileList) {
				this.uploadloading = false;
			},
			// 上传时
			handleProgress(event, file, fileList) {
				this.uploadloading = true;
			},
			// 查看图片
			handleViewImg(img) {
				this.imgList = [];
				if(img.indexOf(',') == -1){
				this.imgList.push(img[0])
				}else{
				this.imgList = img.split(',');
				}
				this.showImg = true;
			},
			//关闭图片
			closeImg() {
				this.showImg = false;
			},
			// 提交
			submit() {
				if (this.inventoryData.length === 0) {
					return this.$message.warning('请添加商品');
				}
				// 上传换标文件
				if(this.hasSkuNewItem){
					if(this.newLabelFileLink.length == 0){
						this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.$t('commonInfo.newLabelFile'));
						return; 
					}
				}
				let query = {
					operationType:'10',// 默认SKU转箱 指令
					remark: this.dialogForm.remark,	
					skuList:[],
					orderType:'stockup',// 指令生成的订单类型
					newLabelLinkList:this.newLabelFileLink,
				}
				this.inventoryData.forEach(item => {
				    query.skuList.push({
						sku_old: item.clientProductCode,
						product_amount: item.count,
						sku_new:item.skuNew,
						swap_cnt:item.swapCnt,

					})
				})
				this.submitLoading = true;
				this.$http.post('/toborder/owh/operationCommand/add', query).then(res => {
					if (res.code == 200) {
						this.$message.success(this.$t('tipsInfo.success'));
						this.submitLoading = false;
						this.handleClose();
						this.$parent.getList();
					} else {
						this.submitLoading = false;
						this.$message.error(res.msg);
					}
				}).catch(error => {
					this.submitLoading = false;
					this.$message.error(error.msg);
				})
			},
			// 取消
			handleClose() {
			    // 重置表单和表格数据、文件上传信息
				this.dialogForm = {
					remark: '',
				};
				this.searchProductCode = '';
				this.inventoryData = [];
				this.hasSkuNewItem = false;
				this.clearFileListFlag = true;
				this.newLabelFileLink = [];
				this.$emit('update:visible', false);
			},
			// 合计
			getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = this.$t('commonInfo.secondTotal');
						return;
					}
					if(column.label == this.$t('commonInfo.orderQuantity')){
						let sum = 0;
						data.map(item => {
							let value = item.count;
							if(value == null || value == undefined){
								value = 0;
							}
							sum += Number(value);
						});
						sums[index] = sum ==0?'':sum;
					} else if(column.label == this.$t('ksaWhFBXOrderPage.newLabelQuantity')){
						let sum = 0;
						data.map(item => {
							let value = item.swapCnt;
							if(value == null || value == undefined){
								value = 0;
							}
							sum += Number(value);
						});
						sums[index] = sum == 0?'':sum;
					} else {
						sums[index] = '';
					}
				});
				return sums;
			}
		}
	};
</script>

<style scoped>
	.fileUploadBtn {
		margin-left: 15px;
	}
</style>